import { useState, useRef } from "react";
import "./editorialForms.css";

const categories = [
  { id: "music", name: "Música" },
  { id: "gaming", name: "Games" },
  { id: "news", name: "Notícias" },
  { id: "sports", name: "Esportes" },
  { id: "education", name: "Educação" },
  { id: "entertainment", name: "Entretenimento" },
  { id: "howto", name: "Como fazer" },
  { id: "science", name: "Ciência" },
  { id: "travel", name: "Viagem" },
  { id: "comedy", name: "Comédia" },
];

export default function YouTubeForm({ data, onChange }) {
  const [tags, setTags] = useState(data?.tags?.join(", ") || "");
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      onChange({ ...data, videoFile: file, videoFileName: file.name });
    }
  };

  const handleTagsChange = (e) => {
    const value = e.target.value;
    setTags(value);
    const tagArray = value
      .split(",")
      .map((tag) => tag.trim())
      .filter((tag) => tag.length > 0);
    onChange({ ...data, tags: tagArray });
  };

  return (
    <div className="editorial_form youtube_form">
      <div className="editorial_form_section">
        <label>
          Vídeo <span className="required">*</span>
        </label>
        <div className="file_upload_area" onClick={() => fileInputRef.current?.click()}>
          <input
            ref={fileInputRef}
            type="file"
            accept="video/*,.mp4,.mov,.avi,.mkv,.webm"
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
          {data?.videoFileName ? (
            <div className="file_selected">
              <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z" />
              </svg>
              <span>{data.videoFileName}</span>
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  onChange({ ...data, videoFile: null, videoFileName: null });
                }}
                className="file_remove_btn"
              >
                ✕
              </button>
            </div>
          ) : (
            <div className="file_placeholder">
              <svg viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
                <path d="M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z" />
              </svg>
              <p>Clique para fazer upload do vídeo</p>
              <span>MP4, MOV, AVI, MKV, WEBM</span>
            </div>
          )}
        </div>
      </div>

      <div className="editorial_form_section">
        <label>
          Título <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Título do vídeo"
          value={data?.title || ""}
          onChange={(e) => onChange({ ...data, title: e.target.value })}
          maxLength={100}
        />
        <span className="editorial_form_counter">
          {(data?.title || "").length}/100
        </span>
      </div>

      <div className="editorial_form_section">
        <label>Descrição</label>
        <textarea
          placeholder="Descrição do vídeo..."
          value={data?.description || ""}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          rows={4}
          maxLength={5000}
        />
        <span className="editorial_form_counter">
          {(data?.description || "").length}/5000
        </span>
      </div>

      <div className="editorial_form_section">
        <label>Categoria</label>
        <select
          value={data?.category || ""}
          onChange={(e) => onChange({ ...data, category: e.target.value })}
        >
          <option value="">Selecione uma categoria</option>
          {categories.map((cat) => (
            <option key={cat.id} value={cat.id}>
              {cat.name}
            </option>
          ))}
        </select>
      </div>

      <div className="editorial_form_section">
        <label>Tags</label>
        <input
          type="text"
          placeholder="tag1, tag2, tag3"
          value={tags}
          onChange={handleTagsChange}
        />
        <span className="editorial_form_hint">Separe as tags por vírgula</span>
      </div>

      <div className="editorial_form_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
        </svg>
        <span>
          Vídeos horizontais (16:9) funcionam melhor para YouTube
        </span>
      </div>
    </div>
  );
}
